import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  comparePropertiesData: [],
  loading: false,
  panelVisible: false,
  largeMapView: 'column'
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROPERTY_COMP_DATA:
      return {
        ...state,
        comparePropertiesData: action.data
      }
    case actionTypes.SET_PROPERTY_COMP_LOADING:
      return {
        ...state,
        loading: action.bool
      }
    case actionTypes.TOGGLE_PANEL:
      return {
        ...state,
        panelVisible: action.bool
      }
    case actionTypes.SET_LARGE_MAP_VIEW:
      return {
        ...state,
        largeMapView: action.view
      }
    case actionTypes.SET_COMP_RELOAD:
      return {
        ...state,
        reload: action.bool
      }
    case actionTypes.SET_COMP_SELECTIONS:
    default:
      return state
  }
}

export default reducer
